/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Major_Sour_Bee_CutInputs */

const fr_major_sour_bee_cut = /** @type {(inputs: Major_Sour_Bee_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes séances en cours`)
};

/**

* @param {Major_Sour_Bee_CutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const major_sour_bee_cut = /** @type {((inputs?: Major_Sour_Bee_CutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Major_Sour_Bee_CutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_major_sour_bee_cut(inputs)
});